import { gql } from '@apollo/client';

const GET_FEATURE_TOGGLES_LIST = gql`
  query getFeatureTogglesList {
    getFeatureTogglesList {
      isActive
      name
      friendlyName
    }
  }
`;

const CURRENT_USER = gql`
  query currentUserHealthCoach {
    currentUserHealthCoach {
      id
      email
      phone
      helpscoutId
      mustCompleteRegistration
      accountLocked
      displayName
      avatar
      calendlyUserId
      calendlyUserEmail
      signature
      initiateConversationMessage
      mentionTag
      passwordExpired
      daysBeforePasswordExpires
    }
  }
`;

// const ADMIN_GET_APPOINTMENTS_LIST = gql`
//   query adminListAppointments {
//     adminListAppointments {
//       startDate
//       endDate
//       subject
//       htmlMessage
//       inviteSubject
//       inviteDescription
//       inviteLocation
//       providerId
//       patientId
//       departmentId
//       appointmentId
//       isZocDoc
//       mustCompleteRegistration
//       patient {
//         id
//         firstName
//         lastName
//       }
//     }
//   }
// `;

const ADMIN_GET_APPOINTMENTS_LIST = gql`
  query healthCoachListUpcomingAppointments {
    healthCoachListUpcomingAppointments {
      date
      appointmentId
      startTime
      departmentId
      appointmentStatus
      scheduledBy
      patientId
      duration
      templateAppointmentTypeId
      hl7ProviderId
      lastModifiedBy
      appointmentTypeId
      lastModified
      appointmentType
      providerId
      chargeEntryNotRequired
      scheduledDateTime
      coordinatorEnterprise
      templateAppointmentId
      patientAppointmentTypename
      mustCompleteRegistration
      isZocDoc
      providerName
      isChartPrepped
      patient {
        id
        firstName
        lastName
      }
    }
  }
`;

const GET_ANALYTICS_ID = gql`
  query getAnalyticsHealthCoachId {
    getAnalyticsHealthCoachId
  }
`;

const APPOINTMENTS = gql`
  query Appointments($includeNut: Boolean) {
    appointments(includeNut: $includeNut) {
      id
      date
      startTime
      status
      appointmentTypeId
      timezoneName
      provider {
        id
        displayName
        zocdocVideoLink
      }
    }
  }
`;

const LABS = gql`
  query Labs {
    labs {
      id
      status
      created
      results {
        pdf
        outcome {
          hormone
          value
          unit
          referenceRange
          abnormal
        }
      }
      currentStep {
        step
        eta
        returnStatus
        delivered
      }
    }
  }
`;

const GET_USER_PCP = gql`
  query getPcp {
    getPcp {
      id
      practice
      address
      address2
      city
      state
      zip
      county
      phone
      fax
      firstname
      lastname
      fullname
      email
      gender
      title
      specialty
      sicCode
      locationAddress
      specialty2
      specialty3
      specialty4
      specialty5
      npi
      internalId
    }
  }
`;

const GET_LAST_SEENS = gql`
  query healthCoachGetLastSeens {
    healthCoachGetLastSeens {
      events {
        uri
        name
        status
        startTime
        endTime
        eventType
        location {
          type
          location
        }
        inviteesCounter {
          total
          active
          limit
        }
        createdAt
        updatedAt
        eventMemberships {
          user
        }
        eventGuests {
          email
          createdAt
          updatedAt
        }
        cancellation {
          canceledBy
          reason
          cancelerType
        }
        calendarEvent {
          kind
          externalId
        }

        invitees {
          uri
          email
          name
          firstName
          lastName
          status
          user {
            id
            athenaId
            firstName
            lastName
            isMobile
            helpscoutId
          }
          questionsAndAnswers {
            question
            answer
            position
          }
          timezone
          event
          createdAt
          updatedAt
          tracking {
            utm_campaign
            utm_source
            utm_medium
            utm_content
            utm_term
            salesforce_uuid
          }
          textReminderNumber
          rescheduled
          cancelUrl
          rescheduleUrl
          cancellation {
            canceledBy
            reason
            cancelerType
          }
          noShow {
            uri
            createdAt
          }
          reconfirmation {
            confirmedAt
            createdAt
          }
        }
      }
      pagination {
        count
        nextPage
        previousPage
        nextPageToken
        previousPageToken
      }
    }
  }
`;

const GET_TODAYS_UPCOMINGS = gql`
  query healthCoachGetTodaysUpcomings {
    healthCoachGetTodaysUpcomings {
      events {
        uri
        name
        status
        startTime
        endTime
        eventType
        location {
          type
          location
        }
        inviteesCounter {
          total
          active
          limit
        }
        createdAt
        updatedAt
        eventMemberships {
          user
        }
        eventGuests {
          email
          createdAt
          updatedAt
        }
        cancellation {
          canceledBy
          reason
          cancelerType
        }
        calendarEvent {
          kind
          externalId
        }

        invitees {
          uri
          email
          name
          firstName
          lastName
          status
          questionsAndAnswers {
            question
            answer
            position
          }
          timezone
          event
          createdAt
          updatedAt
          tracking {
            utm_campaign
            utm_source
            utm_medium
            utm_content
            utm_term
            salesforce_uuid
          }
          textReminderNumber
          rescheduled
          cancelUrl
          rescheduleUrl
          cancellation {
            canceledBy
            reason
            cancelerType
          }
          noShow {
            uri
            createdAt
          }
          reconfirmation {
            confirmedAt
            createdAt
          }
        }
      }
      pagination {
        count
        nextPage
        previousPage
        nextPageToken
        previousPageToken
      }
    }
  }
`;

const GET_UPCOMINGS = gql`
  query healthCoachGetUpcomings($day: String) {
    healthCoachGetUpcomings(day: $day) {
      events {
        uri
        name
        status
        startTime
        endTime
        eventType
        location {
          type
          location
        }
        inviteesCounter {
          total
          active
          limit
        }
        createdAt
        updatedAt
        eventMemberships {
          user
        }
        eventGuests {
          email
          createdAt
          updatedAt
        }
        cancellation {
          canceledBy
          reason
          cancelerType
        }
        calendarEvent {
          kind
          externalId
        }

        invitees {
          uri
          email
          name
          firstName
          lastName
          status
          user {
            id
            athenaId
            firstName
            lastName
            isMobile
            helpscoutId
          }
          questionsAndAnswers {
            question
            answer
            position
          }
          timezone
          event
          createdAt
          updatedAt
          tracking {
            utm_campaign
            utm_source
            utm_medium
            utm_content
            utm_term
            salesforce_uuid
          }
          textReminderNumber
          rescheduled
          cancelUrl
          rescheduleUrl
          cancellation {
            canceledBy
            reason
            cancelerType
          }
          noShow {
            uri
            createdAt
          }
          reconfirmation {
            confirmedAt
            createdAt
          }
        }
      }
      pagination {
        count
        nextPage
        previousPage
        nextPageToken
        previousPageToken
      }
    }
  }
`;

const GET_PATIENT_BY_ID = gql`
  query getProviderPatientById($id: String!) {
    getProviderPatientById(id: $id) {
      user
      athenaId
      firstname
      lastname
      dob
      email
      phone
      photo
      state
      sex
      primaryProvider
      providerGroupName
      fullStateName
      preferredPronouns
      stripeId
      helpscoutId
      isHealthCoachEnabled
      healthCoachingStatus
      perpetualPhysicianConvoId
      startedAIPOn
      forceBypassBridge
      medicalHistory {
        hasHypo
        hasHashi
        hasHyper
        hasDiabetes
        thyroidRemoved
        radiationTherapy
        hypoNotes
        hashiNotes
        hyperNotes
        thyroidRemovedNotes
        radiationTherapyNotes
      }
      isMobileUser
      b2b {
        id
        employeeEmail
        employeeDoB
        employeeFirstName
        employeeLastName
        mustVerify
        internalReferenceID
        employeeId
        verificationUID
        verificationSentDate
        verificationSent
        isActive
        activationDate
        needAdminApproval
        company
        companyId
        eligibility {
          id
          pendingApproval
          isActive
          mustVerify
          verificationSent
          verificationSentDate
        }
      }
    }
  }
`;

const GET_B2B_COMPANY = gql`
  query getHealthCoachB2BCompany($companyId: String!) {
    getHealthCoachB2BCompany(companyId: $companyId) {
      id
      name
      friendlyName
      iconUrl
      freeness {
        id
        kit
        vitamins
        membership
        visits
        async
        expiresAfter
        nutritionist
      }
      restrictions {
        id
        hypo
        meno
        weightloss
      }
      broker {
        id
        name
        friendlyName
        iconUrl
        defaultFreeness {
          id
          kit
          vitamins
          membership
          visits
          async
          expiresAfter
          nutritionist
        }
        defaultRestrictions {
          id
          hypo
          meno
          weightloss
        }
        isActive
        createdAt
        updatedAt
      }
      isActive
      createdAt
      updatedAt
      eligibilityCheckMethod
      whereToFindActivationMethodText
    }
  }
`;

const GET_PATIENT_MEMBERSHIPS_TAGS = gql`
  query gethealthCoachPatientProfileMembershipsTags($athenaId: String!) {
    gethealthCoachPatientProfileMembershipsTags(athenaId: $athenaId) {
      memberships {
        id
        isPaused
        pausedSubscription {
          resumesAt
        }
        isInsuranceMembership
        subscriptionTarget
        subscriptionNickname
        hasCancellationCoupon {
          durationInMonths
          timesRedeemed
          discountPercent
        }
        price
        interval
        intervalCount
        customer
        card {
          id
          brand
          last4
          exp_month
          exp_year
        }
        nextBill {
          amount
          date
        }
        cancels {
          cancelsAt
          cancelAtPeriodEnd
        }
        receipts {
          id
          date
          reference
          amount
          link
        }
      }
    }
  }
`;

const GET_PATIENT_PHOTO = gql`
  query getPatientPhoto($id: String!) {
    getPatientPhoto(id: $id)
  }
`;

const GET_PATIENT_QUICKVIEW = gql`
  query getProviderPatientQuickview($id: String!) {
    getProviderPatientQuickview(id: $id) {
      patientId
      email
      lastName
      firstName
      address1
      address2
      city
      state
      zip
      countryCode
      mobilePhone
      homePhone
      industrycode
      sex
      status
      departmentId
      privacyInformationVerified
      primaryDepartmentId
      emailExists
      patientPhoto
      registrationDate
      guarantorCountryCode
      dob
      guarantorRelationshipToPatient
      consentToText
      countryCode3166
      guarantorCountryCode3166
      primaryProviderId
      lastAppointment
      medicationHistoryConsentVerified
      driverslicenseurl
    }
  }
`;

const GET_INSURANCE_ON_FILE_FOR_PATIENT = gql`
  query getInsurancesOnFileForPatient($patientId: Int!) {
    getInsurancesOnFileForPatient(patientId: $patientId) {
      insurancePolicyHolderCountryCode
      sequenceNumber
      insurancePolicyHolderlastname
      insuredEntityTypeId
      insuranceIdNumber
      insurancePolicyHolderstate
      insurancePolicyHolderzip
      relationshipToInsured
      eligibilityStatus
      policyNumber
      insurancePolicyHolderaddress1
      insurancePackageAddress1
      insurancePolicyHoldersex
      eligibilityReason
      ircName
      insurancePlanName
      insuranceType
      insurancePhone
      insurancePackageState
      insurancePackageCity
      relationshipToInsuredId
      insuranceId
      insurancePolicyHolder
      eligibilityLastChecked
      insurancePolicyHolderFirstName
      insurancePackageId
      insurancePolicyHolderCountryIso3166
      insurancePlanDisplayName
      insurancePolicyHoldercity
      insurancePackageZip
      insuranceCompany
      groupId
      payerId
    }
  }
`;

const GET_CARE_LOCATIONS = gql`
  query getProviderCareLocations($id: String!) {
    getProviderCareLocations(id: $id) {
      pharmacy {
        id
        placeId
        name
        formattedAddress
        phone
        fax
      }
      labCenter {
        id
        placeId
        name
        formattedAddress
        phone
        fax
      }
      pcp {
        id
        practice
        address
        address2
        city
        state
        zip
        county
        phone
        fax
        firstname
        lastname
        fullname
        email
        gender
        title
        specialty
        sicCode
        locationAddress
        specialty2
        specialty3
        specialty4
        specialty5
        npi
        internalId
      }
    }
  }
`;

const SEARCH_PATIENT_BY_NAME = gql`
  query searchProviderPatientsByName($search: String!) {
    searchProviderPatientsByName(search: $search) {
      firstName
      currentDepartmentId
      providerGroupId
      lastName
      localPatientId
      state
      city
      ssn
      countryId
      homePhone
      mobilePhone
      patientId
      sex
      dob
      translatedHomePhoneIndex
      zip
      currentDepartment
      address1
      translatedMobilePhoneIndex
    }
  }
`;

const GET_PATIENT_SYMPTOMS = gql`
  query getProviderPatientOverallSymptoms($id: String!) {
    getProviderPatientOverallSymptoms(id: $id) {
      global {
        date
        hasLabs
        average
        foodTracked {
          id
          date
          time
          rating
          foodCategory
          foodItem
          symptoms
        }
      }
      details {
        id
        name
        color
        textLineColor
        values {
          id
          name
          previousAvg
          values {
            id
            date
            values
          }
        }
      }
    }
  }
`;

const GET_LAB_CHART_VALUES = gql`
  query healthCoachGetLabChartValues($patientId: String!) {
    healthCoachGetLabChartValues(patientId: $patientId) {
      tpo {
        id
        date
        value
        isPaloma
        isSelfEntered
      }
      tsh {
        id
        date
        value
        isPaloma
        isSelfEntered
      }
      ft3 {
        id
        date
        value
        isPaloma
        isSelfEntered
      }
      ft4 {
        id
        date
        value
        isPaloma
        isSelfEntered
      }
      vitD {
        id
        date
        value
        isPaloma
        isSelfEntered
      }
      rT3 {
        id
        date
        value
        isPaloma
        isSelfEntered
      }
    }
  }
`;

const GET_PAID_MOBILE_COURSE_HC = gql`
  query healthCoachGetPaidMobileCourseHc($patientId: String!, $courseId: String!) {
    healthCoachGetPaidMobileCourseHc(patientId: $patientId, courseId: $courseId) {
      id
      price
      paid {
        id
        courseId
        purchasedOn
        stripeConfirmed
        stripeInvoice
        isActive
        amountPaid
        note
        offered
        offeredBy
        stripeReference
        expiresOn
        expiresIfNotStripeConfirmedOn
        healthCoachStatus
        createdAt
      }
    }
  }
`;

const GET_PATIENT_MOBILE_COURSES = gql`
  query providerGetPatientMobileCourses($patientId: String!) {
    providerGetPatientMobileCourses(patientId: $patientId) {
      byWeek {
        week
        journeyName
        courses {
          order
          id
          title
          isStarted
          progress
          isComplete
        }
      }
    }
  }
`;

const GET_PRESET_PLANS = gql`
  query getThyroidPrograms {
    getThyroidPrograms {
      id
      name
      description
      icon
      bgMainColor
      bgBubblesColor
      titleColor
      descriptionColor
      isActive
      isArchived
      isPro
      memberOnly
      createdAt
      updatedAt
      order
      assignedOnly
    }
  }
`;

const GET_CUSTOM_ASSIGNED_PRESET_PLANS = gql`
  query getCustomThyroidProgramsAssignedForPatient($patientId: String!) {
    getCustomThyroidProgramsAssignedForPatient(patientId: $patientId) {
      id
      mobileUserId
      programId
      addedOn
      addedBy
      isActive
      customNotes
      notesForPatient
      hideNoteForPatient
      createdAt
      updatedAt
    }
  }
`;

const GET_THYROID_JOURNEY_SUMMARY = gql`
  query getThyroidJourneySummaryHealthCoach($userId: String!) {
    getThyroidJourneySummaryHealthCoach(userId: $userId) {
      currentWeek
      weeks {
        journeyName
        week
        courses {
          id
          title
          description
          isActive
          isPro
          # journey
          week
          order
          screensColor
          hormoneColor
          icon
          isStarted
          lastLoggedScreen
          isComplete
          progress
          isFoodJournaling
          externalArticleLink
          webflowArticleThumbnail {
            id
            title
            image
          }
        }
      }
      # id
      # title
      # description
      # duration
      # progress
      # isComplete
      # isLocked
      # isAllowed
      # color
      # icon
    }
  }
`;

const GET_THYROID_PROGRAM_SUMMARY = gql`
  query getThyroidProgramSummaryHealthCoach($programId: String!, $userId: String!) {
    getThyroidProgramSummaryHealthCoach(programId: $programId, userId: $userId) {
      section {
        id
        name
        description
        isActive
        isArchived
        isPro
        memberOnly
        createdAt
        updatedAt
        order
      }
      courses {
        id
        title
        description
        bgMainColor
        bgBubblesColor
        titleColor
        descriptionColor
        order
        week
        icon
        webflowArticleId
        externalArticleLink
        isFoodJournaling
        isActive
        isArchived
        isPro
        memberOnly
        createdAt
        updatedAt
        isStarted
        lastLoggedScreen
        progress
        isComplete
        webflowArticleThumbnail {
          id
          title
          image
        }
      }
    }
  }
`;

const GET_APPOINTMENTS_AND_TICKLERS = gql`
  query healthCoachGetAppointmentsAndTicklers($patientId: String!) {
    healthCoachGetAppointmentsAndTicklers(patientId: $patientId) {
      appointments {
        id
        date
        startTime
        status
        appointmentTypeId
        appointmentType
        timezoneName
        encounterId
        duration
        isPrepped
        provider {
          id
          displayName
          zocdocVideoLink
        }
      }
      ticklers {
        approximateDate
        type
      }
    }
  }
`;

const GET_ENCOUNTER_SUMMARY = gql`
  query healthCoachFullEncounterSummary($appointmentId: String!) {
    healthCoachFullEncounterSummary(appointmentId: $appointmentId) {
      Patient_name
      ICD10
      SUBJECTIVE
      OBJECTIVE
      ASSESSMENT
      PRESCRIPTION_WRITTEN
    }
  }
`;

const GET_ENCOUNTER_CONTENT = gql`
  query healthcoachGetEncounterContent($appointmentId: String!) {
    healthcoachGetEncounterContent(appointmentId: $appointmentId) {
      id
      instructions
      goals
      discussionNotes
      assessment
      hpis
      icds {
        description
        code
      }
      physicalExam
      encounterreasons {
        encounterreasons {
          lastmodifieduser
          lastmodifieddatetime
          encounterreasonid
          encounterreasontext
        }
      }
      ros {
        summarytext
        wellchildsummarytext
        sectionnote
      }
      procedures {
        proceduredocumentationtext
        outcome {
          note
          result
          lastmodifiedby
          lastmodifieddatetime
        }
        complications {
          grade
          complication
          lastmodifiedby
          lastmodifieddatetime
        }
      }
    }
  }
`;

const GET_INTAKE_STATUS = gql`
  query healthCoachGetIntakeStatus($athenaId: String!) {
    healthCoachGetIntakeStatus(athenaId: $athenaId) {
      notOk
      message
      notOkMeno
      messageMeno
      notOkWeightloss
      messageWeightloss
    }
  }
`;

const GET_APPOINTMENT_SUMMARY = gql`
  query providerGetAppointmentSummary($appointmentId: String!) {
    providerGetAppointmentSummary(id: $appointmentId) {
      instructions
      goals
      discussionNotes
      assessment
      diagnoses
      prescription {
        encounterId
        orderType
        prescriptionId
        providerId
        description
        instructions
        patientNote
        rxDate
        quantityValue
        dosageQuantity
      }
      physicalExam
      hpi
    }
  }
`;

const GET_APPOINTMENT_NOTES = gql`
  query healthCoachGetAppointmentNotes($appointmentId: String!) {
    healthCoachGetAppointmentNotes(appointmentId: $appointmentId) {
      created
      noteText
      id
    }
  }
`;

const GET_CONVERSATIONS_SEARCH = gql`
  query getHealthCoachSearchConversations($search: String!, $assignedToMe: Boolean, $pageNumber: Int) {
    getHealthCoachSearchConversations(search: $search, assignedToMe: $assignedToMe, pageNumber: $pageNumber) {
      conversations {
        id
        number
        threads
        type
        status
        state
        subject
        mailboxId
        preview
        isClinicalTeam
        userUpdatedAt
        customerWaitingSince {
          time
          friendly
        }
        tags {
          id
          color
          tag
        }
        primaryCustomer {
          id
          type
          first
          last
          email
          photoUrl
        }
        customFields {
          name
          value
          text
        }
      }
      _links {
        self {
          href
        }
        first {
          href
        }
        last {
          href
        }
      }
      page {
        size
        totalElements
        totalPages
        number
      }
    }
  }
`;

const GET_CARE_TEAM_CONVERSATION_ID = gql`
  query healthCoachGetCareTeamConversationId($helpscoutId: String!) {
    healthCoachGetCareTeamConversationId(helpscoutId: $helpscoutId)
  }
`;

const GET_CONVERSATIONS_BY_APPOINTMENT_ID = gql`
  query healthCoachGetCareTeamConversation($helpscoutId: String!) {
    healthCoachGetCareTeamConversation(helpscoutId: $helpscoutId) {
      id
      number
      thread
      type
      folderId
      status
      state
      subject
      preview
      mailboxId
      assignee {
        id
        type
        first
        last
        photoUrl
        email
      }
      createdBy {
        id
        type
        first
        last
        photoUrl
        email
      }
      createdAt
      closedBy
      closedByUser {
        id
        type
        first
        last
        photoUrl
        email
      }
      userUpdatedAt
      customerWaitingSince {
        time
        friendly
      }
      source {
        type
        via
      }
      # tags:
      cc {
        id
        type
        first
        last
        photoUrl
        email
      }
      bcc {
        id
        type
        first
        last
        photoUrl
        email
      }
      primaryCustomer {
        id
        type
        first
        last
        photoUrl
        email
      }
      customFields {
        id
        name
        value
        text
      }
      threads {
        id
        type
        status
        state
        body
        savedReplyId
        createdAt
        openedAt
        _embedded {
          attachments {
            id
            filename
            mimeType
            _links {
              web {
                href
              }
            }
          }
        }
        bcc {
          id
          type
          first
          last
          photoUrl
          email
        }
        cc {
          id
          type
          first
          last
          photoUrl
          email
        }
        to {
          id
          type
          first
          last
          photoUrl
          email
        }
        assignedTo {
          id
          type
          first
          last
          photoUrl
          email
        }
        createdBy {
          id
          type
          first
          last
          photoUrl
          email
        }
        customer {
          id
          type
          first
          last
          photoUrl
          email
        }
        source {
          type
          via
        }
      }
    }
  }
`;

const GET_CONVERSATIONS = gql`
  query getHealthCoachConversations($pageNumber: Int, $status: String, $hcOnly: Boolean) {
    getHealthCoachConversations(pageNumber: $pageNumber, status: $status, hcOnly: $hcOnly) {
      conversations {
        id
        number
        threads
        type
        status
        state
        subject
        mailboxId
        preview
        isClinicalTeam
        userUpdatedAt
        customerWaitingSince {
          time
          friendly
        }
        tags {
          id
          color
          tag
        }
        primaryCustomer {
          id
          type
          first
          last
          email
          photoUrl
        }
        customFields {
          name
          value
          text
        }
      }
      _links {
        self {
          href
        }
        first {
          href
        }
        last {
          href
        }
      }
      page {
        size
        totalElements
        totalPages
        number
      }
    }
  }
`;

const GET_HELPSCOUT_USERS = gql`
  query getHelpscoutUsers {
    getHelpscoutUsers {
      id
      firstName
      lastName
      email
      role
      timezone
      type
      photoUrl
      initials
      mention
      jobTitle
      phone
      alternateEmails
    }
  }
`;

const GET_CLINICAL_TEAM_CONVERSATION_ID = gql`
  query getPatientClinicalTeamActiveConversationId($athenaId: String!) {
    getPatientClinicalTeamActiveConversationId(athenaId: $athenaId)
  }
`;

const GET_CONVERSATION_BY_ID = gql`
  query providerGetConversationById($conversationId: String!) {
    providerGetConversationById(conversationId: $conversationId) {
      id
      number
      threads
      type
      folderId
      status
      state
      subject
      preview
      mailboxId
      mailbox
      isClinicalTeam
      athenaId
      misHealthcoachEnabled
      msnooze {
        athenaId
        conversationId
        reactivateOn
        createdOn
        recordId
        isManualSnooze
      }
      assignee {
        id
        type
        first
        last
        email
      }
      createdBy {
        id
        type
        email
      }
      createdAt
      closedBy
      closedByUser {
        id
        type
        first
        last
        photoUrl
        email
      }
      closedAt
      userUpdatedAt
      convoTree {
        tree
        parent
      }
      customerWaitingSince {
        time
        friendly
      }
      tags {
        id
        color
        tag
      }
      cc
      bcc
      primaryCustomer {
        id
        type
        first
        last
        email
      }
      customFields {
        name
        value
        text
      }
      _embedded {
        threads {
          id
          type
          status
          state
          draft
          action {
            type
            text
          }
          body
          customer {
            id
            type
            first
            last
            email
            photoUrl
          }
          createdBy {
            id
            type
            first
            last
            email
            photoUrl
          }
          createdAt
          openedAt
          _embedded {
            attachments {
              id
              filename
              mimeType
              width
              height
              _links {
                self {
                  href
                }
                data {
                  href
                }
                web {
                  href
                }
              }
            }
          }
        }
      }
      _links {
        self {
          href
        }
        first {
          href
        }
        last {
          href
        }
      }
      page {
        size
        totalElements
        totalPages
        number
      }
    }
  }
`;

const GET_DASHBOARD_CARDS_DATA = gql`
  query getHealthCoachDashboardCardsData {
    getHealthCoachDashboardCardsData {
      servedPerDay {
        date
        customers
      }
      servedLast7Days
      onboardingCallThisMonth
      onboardingCallLastMonth
      onboardingCallFuture
      activeHealthCoaching
      totalAssignedConvos
      handleTime
      # customerSatisfaction {
      #   okay
      #   notGoodCount
      #   totalCustomers
      #   happinessScore
      #   totalConversationsWithRatings
      #   totalCustomersWithRatings
      #   ratingsCount
      #   ratingsPercent
      #   notGood
      #   great
      #   greatCount
      #   okayCount
      # }
      underCare
    }
  }
`;

const GET_OPEN_CONVERSATION_COUNT = gql`
  query getHealthCoachConversationsOpenedCount {
    getHealthCoachConversationsOpenedCount {
      count
    }
  }
`;

const GET_CURRENT_INTAKE_VALUES = gql`
  query getProviderCurrentIntakeValues($id: String!) {
    getProviderCurrentIntakeValues(id: $id) {
      medicalhistory {
        question
        answer
        note
        questionId
      }
      gynhistory {
        question
        answer
        note
        questionId
      }
      allergies {
        rxnormcode
        allergenid
        allergenname
        note
        lastmodifiedby
        deactivateduser
        criticality
        deactivatedate
        reactions {
          severitysnomedcode
          reactionname
          snomedcode
          severity
        }
      }
      familyHistory {
        relation
        problems {
          problemId
          snomedcode
          note
          description
        }
      }
      socialHistory {
        question
        answer
        note
        questionId
      }
      surgicalHistory {
        description
        procedureid
        note
        procedurecode
      }
      problems {
        id
        lastModifiedDateTime
        name
        problemId
        events {
          eventtype
          startdate
          note
          createddate
          createdby
        }
        code
      }
    }
  }
`;

const GET_PROFILE = gql`
  query getHealthCoachProfile {
    getHealthCoachProfile {
      id
      email
      helpscoutId
      phone
      passwordExpiresAt
      displayName
      calendlyUserId
      calendlyUserEmail
      bio
      acceptNew
      isActive
      isFallback
      timeZone
      thumbnail
      calendlyLink
    }
  }
`;

const GET_MEDICATIONS_ON_FILE = gql`
  query providerGetMedicationsForPatient($id: String!) {
    providerGetMedicationsForPatient(id: $id) {
      medicationId
      medication
      dose
      frequency
      isActive
      events {
        eventdate
        type
        userdisplayname
      }
    }
  }
`;

const GET_MEDICATION_REMINDERS = gql`
  query providerGetMedicationRemindersForPatient($id: String!) {
    providerGetMedicationRemindersForPatient(id: $id) {
      id
      medicationName
      dose
      frequency
      times
      isActive
      notify
    }
  }
`;

const GET_CALENDAR_FOR_MONTH = gql`
  query getProviderCalendarForMonth($date: String!) {
    getProviderCalendarForMonth(date: $date) {
      openSlots {
        id
        date
        count
      }
      booked {
        id
        date
        count
      }
    }
  }
`;

const GET_CALENDAR_BETWEEN_DATES = gql`
  query getProviderCalendarBetweenDates($startDate: String!, $endDate: String!) {
    getProviderCalendarBetweenDates(startDate: $startDate, endDate: $endDate) {
      openSlots {
        id
        date
        count
      }
      booked {
        id
        date
        count
      }
    }
  }
`;

const GET_LABS_LIST = gql`
  query providersGetLabLists($patientId: String!) {
    providersGetLabLists(patientId: $patientId) {
      date
      labResultId
      attachmentExists
      lab
      status
      analytes {
        analyte
        abnormalflag
        value
        unit
        status
        isManualUpload
        resultStatus
        analyteid
        id
      }
    }
  }
`;

const GET_KIT_STATUS = gql`
  query healthCoachGetKitStatus($labResultId: String!) {
    healthCoachGetKitStatus(labResultId: $labResultId) {
      id
      status
      barcode
      deliveryToPatientDate
      deliveryToLabDate
      businessDaysSinceLabReceipt
      slowLabFlag
      etaToCustomer
      etaToLab
      etaResults
      trackKitToCustomer
      trackKitToLab
      orderId
      alliedRef
    }
  }
`;

const GET_LAB_RESULT_DOCUMENTS = gql`
  query providerGetLabResultDocuments($patientId: String!, $labResultId: Int!) {
    providerGetLabResultDocuments(patientId: $patientId, labResultId: $labResultId) {
      pageordering
      pageid
      contenttype
    }
  }
`;

const GET_LAB_RESULT_DOCUMENTS_PAGE = gql`
  query providerGetLabResultDocumentsPage($patientId: String!, $labResultId: Int!, $pageId: String!) {
    providerGetLabResultDocumentsPage(patientId: $patientId, labResultId: $labResultId, pageId: $pageId) {
      attachement
      mimeType
    }
  }
`;

const GET_AIP_RECIPES_BY_FILTER = gql`
  query getAipRecipesByFilterFromWeb($filterText: String, $filterCategory: FilterMealTypes, $idsToExclude: [String], $excludedAllergens: [String]) {
    getAipRecipesByFilterFromWeb(filterText: $filterText, filterCategory: $filterCategory, idsToExclude: $idsToExclude, excludedAllergens: $excludedAllergens) {
      name
      image
      id
      serving
      totalTimeMinutes
    }
  }
`;

const GET_AIP_RECIPE = gql`
  query getAipRecipeFromWeb($id: String!) {
    getAipRecipeFromWeb(id: $id) {
      id
      airtableId
      name
      image
      serving
      activeTimeMinutes
      totalTimeMinutes
      calories
      ingredients
      instructions
      options
      author
      authorBio
      authorImage
      instagramLink
      authorWebsite
      highProtein
      balanced
      lowFat
      highFiber
      lowCarb
      lowSodium
      vegan
      vegetarian
      paleo
      dairyFree
      glutenFree
      wheatFree
      fatFree
      lowSugar
      eggFree
      nightshadeFree
      alcoholFree
      caffeineFree
      peanutFree
      treeNutFree
      soyFree
      fishFree
      shellfishFree
      breakfast
      lunch
      dinner
      snack
      active
      isFavorite
    }
  }
`;

const GET_ARTICLES_FOR_CATEGORY = gql`
  query getArticlesInCategoryFromWeb($categoryId: String, $take: Int, $skip: Int, $filter: String, $favorites: Boolean, $idsToExclude: [String]) {
    getArticlesInCategoryFromWeb(categoryId: $categoryId, take: $take, skip: $skip, filter: $filter, favorites: $favorites, idsToExclude: $idsToExclude) {
      title
      thumbnailUrl
      id
      content
      quickPostSummary
      readMore
      tag {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

const GET_ARTICLES_CATEGORIES = gql`
  query getArticleCategories {
    getArticleCategories {
      id
      name
    }
  }
`;

const GET_RANDOM_ARTICLES_WITH_TAG = gql`
  query getArticlesWithTag($limit: Int, $tag: String!) {
    getArticlesWithTag(limit: $limit, tag: $tag) {
      title
      thumbnailUrl
      id
      tag {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

const GET_ARTICLE_BY_ID = gql`
  query getArticleByIdFromWeb($id: String!) {
    getArticleByIdFromWeb(id: $id) {
      title
      thumbnailUrl
      id
      content
      quickPostSummary
      readMore
      isFavorite
      tag {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

const GET_SPEAKER_SERIES = gql`
  query getSpeakerSeries {
    getSpeakerSeries {
      name
      slug
      publishedOn
      smallDescription
      duration
      videoLink
      descriptionCopy
      image
      description
      speaker_1
      codeFromHttpsAppSistrixComEnVideoSnippetGenerator
      transcript
      embedUrl
      videoLinkMp4Mov
      speaker_2
      itemId
      createdOn
      speaker_3
      updatedOn
      thumbnailUrl
      rid
      collectionId
      airtableId
      id
    }
  }
`;

const GET_THYROID_GUIDES = gql`
  query getThyroidGuides {
    getThyroidGuides {
      name
      slug
      collectionId
      itemId
      guidePdfLink
      title
      summary
      bgColor
      image
      subtitle
      description
      included1
      included1Image
      included1Description
      included2
      included2Image
      included2Description
      included3
      included3Image
      included3Description
      included4
      included4Image
      included4Description
      order
      airtableId
      id
    }
  }
`;

const GET_PATIENT_CHART_ALERTS = gql`
  query getProviderPatientChartAlert($id: String!) {
    getProviderPatientChartAlert(id: $id) {
      lastmodified
      notetext
      lastmodifiedby
    }
  }
`;

const GET_PATIENT_BASELINE_SURVEY_ANSWERS = gql`
  query getBaselineSurveyAnswersProvider($id: String!) {
    getBaselineSurveyAnswersProvider(id: $id) {
      id
      status
      values
      updatedAt
    }
  }
`;

const GET_PATIENT_FOLLOWUP_SURVEY_ANSWERS = gql`
  query getFollowUpSurveyAnswersProvider($surveyName: String!, $id: String!) {
    getFollowUpSurveyAnswersProvider(surveyName: $surveyName, id: $id) {
      survey
      answers {
        id
        status
        values
        updatedAt
      }
    }
  }
`;

const GET_PATIENT_SURVEYS_AVERAGES = gql`
  query providerSurveyAnswersProvider($id: String!) {
    providerSurveyAnswersProvider(id: $id) {
      survey
      avg {
        hypothyroidSymptoms {
          values
          answers {
            question
            value
            answer
          }
        }
        tiredness {
          values
          answers {
            question
            value
            answer
          }
        }
        cognitiveComplaints {
          values
          answers {
            question
            value
            answer
          }
        }
        anxiety {
          values
          answers {
            question
            value
            answer
          }
        }
        depressivity {
          values
          answers {
            question
            value
            answer
          }
        }
        impairedDailyLife {
          values
          answers {
            question
            value
            answer
          }
        }
        cosmeticComplaints {
          values
          answers {
            question
            value
            answer
          }
        }
        overallQoL {
          values
          answers {
            question
            value
            answer
          }
        }
      }
    }
  }
`;

const GET_PATIENT_SURVEYS_INFO = gql`
  query getSurveysInfoProvider($id: String!) {
    getSurveysInfoProvider(id: $id) {
      mustCompleteBaselineSurvey
      statuses {
        id
        name
        status
        triggerOn
        lastUpdatedOn
      }
    }
  }
`;

const GET_PATIENT_CASES = gql`
  query providerGetPatientCases($patientId: String!) {
    providerGetPatientCases(patientId: $patientId) {
      id
      appointmentId
      assignedTo
      clinicalProviderId
      createdDate
      createdDatetime
      createdUser
      deletedDatetime
      departmentId
      description
      documentClass
      documentDescription
      documentRoute
      documentSource
      documentSubclass
      documentTypeId
      encounterId
      externalAccessionId
      externalNote
      facilityId
      internalAccessionId
      internalNote
      lastModifiedDate
      lastModifiedDatetime
      lastModifiedUser
      observationDatetime
      patientCaseAttachments
      patientCaseId
      patientId
      phoneMessageId
      priority
      providerId
      status
      subject
      tieToOrderId
      hcFilledFormId
    }
  }
`;

const GET_PATIENT_CASE = gql`
  query providerGetPatientCase($patientId: String!, $patientCaseId: String!) {
    providerGetPatientCase(patientId: $patientId, patientCaseId: $patientCaseId) {
      id
      actionNote
      assignedTo
      callbackName
      callbackNumber
      callbackNumberType
      callType
      clinicalProviderId
      createdDate
      createdDatetime
      createdUser
      deletedDatetime
      departmentId
      description
      documentClass
      documentDescription
      documentRoute
      documentSubclass
      documentTypeId
      encounterId
      externalAccessionId
      externalNote
      facilityId
      internalAccessionId
      internalNote
      lastModifiedDate
      lastModifiedDatetime
      lastModifiedUser
      observationdatetime
      outboundOnly
      patientCaseAttachments
      patientCaseId
      patientId
      priority
      providerId
      providerUsername
      status
      subject
      tiedToProcedureOrSurgery
      tieToOrderId
      filledForm {
        id
        healthCoach {
          id
          displayName
        }
        form {
          id
          name
          description
        }
        values
        updatedAt
      }
    }
  }
`;

const GET_TALKING_POINTS = gql`
  query providerGetTalkingPoints($patientId: String!) {
    providerGetTalkingPoints(patientId: $patientId) {
      id
      palomaExpectations
      thyroidMedAdjustment
      overallWellBeing
      isMobileUser
      bmi {
        feet
        inches
        weight
        bmi
        bmiString
        timestamp
      }
      flags {
        marker
        currentFlag
        previousFlag
        currentValue
        previousValue
        previousUnit
        currentUnit
      }
      problems {
        id
        lastModifiedDateTime
        name
        problemId
        code
        events {
          eventtype
          startdate
          note
          createddate
          createdby
        }
      }
    }
  }
`;

const GET_HEALTHCOACH_FORM_TARGETS = gql`
  query getHealthCoachFormTargets {
    getHealthCoachFormTargets {
      id
      target
      canHaveMultiple
      isActive
      isDeprecated
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

const GET_HEALTHCOACH_FORM_TEMPLATES = gql`
  query getHealthCoachFormTemplates {
    getHealthCoachFormTemplates {
      id
      creator {
        id
        email
        firstName
      }
      version
      content
      target {
        id
        target
      }
      name
      description
      basedOnTemplate {
        id
        name
      }
      isActive
      isDeprecated
      isDeleted
      createdAt
      updatedAt
      associatedForms {
        id
        creator {
          id
          email
          displayName
        }
        version
        content
        target {
          id
          target
        }
        name
        description
        basedOnTemplate {
          id
          name
        }
        isActive
        isDeprecated
        isDeleted
        createdAt
        updatedAt
        inLibraryOf {
          id
          name
          email
          isFavorite
          isActive
        }
      }
    }
  }
`;

const GET_MY_FORMS_LIST = gql`
  query getMyHealthCoachFormsList {
    getMyHealthCoachFormsList {
      target {
        id
        target
        multipleAllowed
      }
      mine {
        id
        name
        description
        isActive
        isDeleted
        createdAt
        updatedAt
        version
        isFavorite
        formId
        formUpdatedAt
        formCreatorId
        formCreatorDisplayName
        builderUpdatedAt
        basedOnTemplate {
          id
          name
        }
        createdBy {
          id
          email
          firstName
          displayName
        }
      }
      others {
        id
        name
        description
        isActive
        isDeleted
        createdAt
        updatedAt
        version
        builderUpdatedAt
        basedOnTemplate {
          id
          name
        }
        createdBy {
          id
          email
          firstName
          displayName
        }
      }
      template {
        id
        name
        description
        creator {
          id
          email
          firstName
        }
        createdAt
        updatedAt
        builderUpdatedAt
      }
    }
  }
`;

const GET_TEMPLATE_CONTENT = gql`
  query getTemplateContent($templateId: String!) {
    getTemplateContent(templateId: $templateId) {
      id
      creator {
        id
        email
        firstName
      }
      version
      content
      target {
        id
        target
      }
      name
      description
      basedOnTemplate {
        id
        name
      }
      isActive
      isDeprecated
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

const GET_FORM_CONTENT = gql`
  query getFormContent($formId: String!) {
    getFormContent(formId: $formId) {
      id
      creator {
        id
        email
        firstName
      }
      version
      content
      target {
        id
        target
      }
      name
      description
      basedOnTemplate {
        id
        name
        builderUpdatedAt
      }
      isActive
      isDeprecated
      isDeleted
      createdAt
      updatedAt
      builderUpdatedAt
    }
  }
`;

const GET_HS_TAGS_LIST = gql`
  query getHelpscoutTagsList {
    getHelpscoutTagsList {
      tags {
        id
        slug
        name
        color
        createdAt
        ticketCount
      }
    }
  }
`;

const GET_HS_SAVED_REPLIES = gql`
  query getHSSavedReplies($mailboxId: String!) {
    getHSSavedReplies(mailboxId: $mailboxId) {
      id
      name
      preview
    }
  }
`;

const GET_HS_SAVED_REPLY = gql`
  query getHSSavedReply($mailboxId: String!, $savedReplyId: String!) {
    getHSSavedReply(mailboxId: $mailboxId, savedReplyId: $savedReplyId) {
      id
      name
      text
      chatText
    }
  }
`;

const GET_UNREAD_INXS = gql`
  query getHealthCoachUnreadInxsCount {
    getHealthCoachUnreadInxsCount {
      count
    }
  }
`;

const GET_INXS = gql`
  query getHealthCoachInxs {
    getHealthCoachInxs {
      id
      readAt
      inxs {
        id
        severity
        description
        title
        updatedAt
        creator
      }
    }
  }
`;

const GET_HEALTHCOACHING_PATIENTS_LIST = gql`
  query getHealthCoachingPatientsList($page: Int, $onlyMe: Boolean) {
    getHealthCoachingPatientsList(page: $page, onlyMe: $onlyMe) {
      patients {
        id
        athenaId
        firstName
        lastName
        email
        phone
      }
      page {
        currentPage
        totalPages
        totalPatients
      }
    }
  }
`;

const GET_COURSES_ANSWERS = gql`
  query healthCoachGetPatientMobileCoursesAnswers($patientId: String!, $courseId: String!) {
    healthCoachGetPatientMobileCoursesAnswers(patientId: $patientId, courseId: $courseId) {
      id
      isCompleted
      selectedOptions
      isStarted
      journaling
      date
      buttonClicked
      courseScreen {
        hormoneY
        Content
        externalArticleLink
        webflowArticleId
        textStyle
        titleStyle
        options
        buttons
        order
        title
      }
    }
  }
`;

const GET_PRESET_PLAN_COURSES_ANSWERS = gql`
  query healthCoachGetPatientMobilePresetPlanAnswers($patientId: String!, $courseId: String!) {
    healthCoachGetPatientMobilePresetPlanAnswers(patientId: $patientId, courseId: $courseId) {
      id
      isCompleted
      selectedOptions
      isStarted
      journaling
      date
      buttonClicked
      programCourseScreen {
        hormoneY
        content
        externalArticleLink
        webflowArticleId
        textStyle
        titleStyle
        options
        buttons
        order
        title
      }
    }
  }
`;

const GET_AIP_COURSES_ENGAGEMENT_CHART_VALUES = gql`
  query getAIPEngagementChartValues($patientId: String!) {
    getAIPEngagementChartValues(patientId: $patientId) {
      day
      count
    }
  }
`;

const GET_PRESET_PLAN_COURSES_ENGAGEMENT_CHART_VALUES = gql`
  query getPresetPlanEngagementChartValues($patientId: String!, $programId: String!) {
    getPresetPlanEngagementChartValues(patientId: $patientId, programId: $programId) {
      day
      count
    }
  }
`;

const GET_HC_STICKY_NOTE = gql`
  query getHealthcoachStickyNote($id: String!) {
    getHealthcoachStickyNote(id: $id) {
      id
      note
    }
  }
`;

const GET_HC_PATIENT_CALENDLY_EVENTS = gql`
  query healthCoachGetCalendlyEventsForPatient($id: String!) {
    healthCoachGetCalendlyEventsForPatient(id: $id) {
      events {
        uri
        name
        status
        startTime
        endTime
        eventType
        location {
          type
          location
        }
        inviteesCounter {
          total
          active
          limit
        }
        createdAt
        updatedAt
        eventMemberships {
          user
        }
        eventGuests {
          email
          createdAt
          updatedAt
        }
        cancellation {
          canceledBy
          reason
          cancelerType
        }
        calendarEvent {
          kind
          externalId
        }

        invitees {
          uri
          email
          name
          firstName
          lastName
          status
          questionsAndAnswers {
            question
            answer
            position
          }
          timezone
          event
          createdAt
          updatedAt
          tracking {
            utm_campaign
            utm_source
            utm_medium
            utm_content
            utm_term
            salesforce_uuid
          }
          textReminderNumber
          rescheduled
          cancelUrl
          rescheduleUrl
          cancellation {
            canceledBy
            reason
            cancelerType
          }
          noShow {
            uri
            createdAt
          }
          reconfirmation {
            confirmedAt
            createdAt
          }
        }
      }
      pagination {
        count
        nextPage
        previousPage
        nextPageToken
        previousPageToken
      }
    }
  }
`;

const GET_FOOD_TRACKING = gql`
  query hcGetFoodTracking($patientId: String!) {
    hcGetFoodTracking(patientId: $patientId) {
      id
      date
      time
      foodCategory
      foodItem
      symptoms
      rating
      createdAt
      updatedAt
    }
  }
`;

const GET_PATIENT_WELLNESS_PLAN = gql`
  query healthCoachGetPatientWellnessPlan($userId: String!) {
    healthCoachGetPatientWellnessPlan(userId: $userId) {
      id
      plan
      updatedAt
      createdAt
      isDeleted
      internalNotes
      revisionFromId
    }
  }
`;

const GET_HEALTH_COACH_VISIT_SUMMARIES = gql`
  query healthCoachGetPatientVisitSummariesForVisit($calendlyUri: String!) {
    healthCoachGetPatientVisitSummariesForVisit(calendlyUri: $calendlyUri) {
      id
      summary
      visitDate
      calendlyUri
      internalNotes
      internalForm
      courseId
    }
  }
`;

const GET_HEALTH_COACH_VISIT_SUMMARIES_ALL = gql`
  query healthCoachGetPatientVisitSummaries($userId: String!) {
    healthCoachGetPatientVisitSummaries(userId: $userId) {
      id
      summary
      visitDate
      calendlyUri
      internalNotes
      internalForm
      courseId
    }
  }
`;

const GET_PATIENT_CONVERSATIONS_LIST = gql`
  query healthCoachGetPatientConversationsList($patientId: String!) {
    healthCoachGetPatientConversationsList(patientId: $patientId) {
      id
      subject
      preview
      status
      threads
      assignedTo
      waiting
    }
  }
`;

export {
  GET_FEATURE_TOGGLES_LIST,
  CURRENT_USER,
  GET_ANALYTICS_ID,
  APPOINTMENTS,
  LABS,
  GET_USER_PCP,
  GET_LAST_SEENS,
  GET_UPCOMINGS,
  GET_PATIENT_BY_ID,
  SEARCH_PATIENT_BY_NAME,
  GET_PATIENT_SYMPTOMS,
  GET_LAB_CHART_VALUES,
  GET_PATIENT_MOBILE_COURSES,
  GET_APPOINTMENTS_AND_TICKLERS,
  GET_APPOINTMENT_SUMMARY,
  GET_CONVERSATIONS,
  GET_HELPSCOUT_USERS,
  GET_CONVERSATION_BY_ID,
  GET_CONVERSATIONS_SEARCH,
  GET_PATIENT_QUICKVIEW,
  GET_INSURANCE_ON_FILE_FOR_PATIENT,
  GET_CARE_LOCATIONS,
  GET_CONVERSATIONS_BY_APPOINTMENT_ID,
  GET_DASHBOARD_CARDS_DATA,
  GET_OPEN_CONVERSATION_COUNT,
  GET_CURRENT_INTAKE_VALUES,
  GET_PROFILE,
  GET_MEDICATIONS_ON_FILE,
  GET_MEDICATION_REMINDERS,
  GET_CALENDAR_FOR_MONTH,
  GET_TODAYS_UPCOMINGS,
  GET_LABS_LIST,
  GET_LAB_RESULT_DOCUMENTS,
  GET_LAB_RESULT_DOCUMENTS_PAGE,
  GET_AIP_RECIPES_BY_FILTER,
  GET_AIP_RECIPE,
  GET_ARTICLES_FOR_CATEGORY,
  GET_ARTICLES_CATEGORIES,
  GET_RANDOM_ARTICLES_WITH_TAG,
  GET_ARTICLE_BY_ID,
  GET_SPEAKER_SERIES,
  GET_THYROID_GUIDES,
  GET_PATIENT_CHART_ALERTS,
  GET_CALENDAR_BETWEEN_DATES,
  GET_PATIENT_PHOTO,
  GET_PATIENT_BASELINE_SURVEY_ANSWERS,
  GET_PATIENT_FOLLOWUP_SURVEY_ANSWERS,
  GET_PATIENT_SURVEYS_INFO,
  GET_PATIENT_CASES,
  GET_PATIENT_CASE,
  GET_TALKING_POINTS,
  GET_PATIENT_SURVEYS_AVERAGES,
  GET_HEALTHCOACH_FORM_TARGETS,
  GET_HEALTHCOACH_FORM_TEMPLATES,
  GET_MY_FORMS_LIST,
  GET_TEMPLATE_CONTENT,
  GET_FORM_CONTENT,
  GET_PRESET_PLANS,
  GET_THYROID_PROGRAM_SUMMARY,
  GET_THYROID_JOURNEY_SUMMARY,
  GET_HS_TAGS_LIST,
  GET_PATIENT_MEMBERSHIPS_TAGS,
  GET_CLINICAL_TEAM_CONVERSATION_ID,
  GET_CARE_TEAM_CONVERSATION_ID,
  GET_UNREAD_INXS,
  GET_INXS,
  GET_KIT_STATUS,
  GET_INTAKE_STATUS,
  GET_HEALTHCOACHING_PATIENTS_LIST,
  GET_HS_SAVED_REPLIES,
  GET_HS_SAVED_REPLY,
  GET_COURSES_ANSWERS,
  GET_PRESET_PLAN_COURSES_ANSWERS,
  GET_CUSTOM_ASSIGNED_PRESET_PLANS,
  GET_AIP_COURSES_ENGAGEMENT_CHART_VALUES,
  GET_PRESET_PLAN_COURSES_ENGAGEMENT_CHART_VALUES,
  GET_HC_STICKY_NOTE,
  GET_B2B_COMPANY,
  GET_HC_PATIENT_CALENDLY_EVENTS,
  GET_FOOD_TRACKING,
  GET_PAID_MOBILE_COURSE_HC,
  GET_PATIENT_WELLNESS_PLAN,
  GET_HEALTH_COACH_VISIT_SUMMARIES,
  GET_HEALTH_COACH_VISIT_SUMMARIES_ALL,
  GET_APPOINTMENT_NOTES,
  ADMIN_GET_APPOINTMENTS_LIST,
  GET_ENCOUNTER_CONTENT,
  GET_ENCOUNTER_SUMMARY,
  GET_PATIENT_CONVERSATIONS_LIST,
};
